import { useState } from "react";
import {
  FullScreenButtonRoot,
  FullScreenButtonIcon,
} from "./FullScreenButton.styles";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

export const FullScreenButton = () => {
  const texts = {
    fullScreen: "Open fullscreen mode",
    exitFullScreen: "Exit fullscreen mode",
  };

  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleFullScreen = () => {
    const handleScreenChangeEvent = () => {
      document.removeEventListener("fullscreenchange", handleScreenChangeEvent);
      setIsFullScreen(false);
    };

    setIsFullScreen(true);
    document.documentElement
      .requestFullscreen()
      .then(() =>
        requestAnimationFrame(() =>
          document.addEventListener("fullscreenchange", handleScreenChangeEvent)
        )
      )
      .catch(() => {});
  };

  const handleExitFullScreen = () => {
    const handleScreenChangeEvent = () => {
      document.removeEventListener("fullscreenchange", handleScreenChangeEvent);
      setIsFullScreen(true);
    };

    setIsFullScreen(false);
    document
      .exitFullscreen()
      .then(() =>
        requestAnimationFrame(() =>
          document.addEventListener("fullscreenchange", handleScreenChangeEvent)
        )
      )
      .catch(() => {});
  };

  return (
    <FullScreenButtonRoot>
      {isFullScreen ? (
        <FullScreenButtonIcon
          onClick={() => handleExitFullScreen()}
          title={texts.exitFullScreen}
        >
          <FullscreenExitIcon sx={{ fontSize: "3rem" }} />
        </FullScreenButtonIcon>
      ) : (
        <FullScreenButtonIcon
          onClick={() => handleFullScreen()}
          title={texts.fullScreen}
        >
          <FullscreenIcon sx={{ fontSize: "3rem" }} />
        </FullScreenButtonIcon>
      )}
    </FullScreenButtonRoot>
  );
};
